<template>
  <div>
    <b-card :title="$t('settings.governorate.details')">
      <b-row v-if="governorate">
        <b-col
          cols="12"
          md="6"
        >
          <dl class="row">
            <dt class="col-sm-4">
              {{ $t('settings.governorate.name_ar') }}:
            </dt>
            <dd class="col-sm-8">
              {{ governorate.name_ar }}
            </dd>

            <dt class="col-sm-4">
              {{ $t('settings.governorate.name_en') }}:
            </dt>
            <dd class="col-sm-8">
              {{ governorate.name_en }}
            </dd>

            <dt class="col-sm-4">
              {{ $t('settings.governorate.code') }}:
            </dt>
            <dd class="col-sm-8">
              {{ governorate.code }}
            </dd>
          </dl>
        </b-col>

        <b-col
          cols="12"
          md="6"
        >
          <dl class="row">
            <dt class="col-sm-4">
              {{ $t('common.status') }}:
            </dt>
            <dd class="col-sm-8">
              <b-badge :variant="governorate.is_active ? 'success' : 'danger'">
                {{ governorate.is_active ? $t('common.active') : $t('common.inactive') }}
              </b-badge>
            </dd>

            <dt class="col-sm-4">
              {{ $t('settings.governorate.cities_count') }}:
            </dt>
            <dd class="col-sm-8">
              {{ governorate.cities_count }}
            </dd>

            <dt class="col-sm-4">
              {{ $t('settings.governorate.authorities_count') }}:
            </dt>
            <dd class="col-sm-8">
              {{ governorate.authorities_count }}
            </dd>
          </dl>
        </b-col>

        <b-col
          cols="12"
          class="mt-2"
        >
          <b-button
            variant="primary"
            :to="{ name: 'settings-governorates-edit', params: { id: $route.params.id } }"
          >
            {{ $t('common.edit') }}
          </b-button>
          <b-button
            variant="outline-secondary"
            class="ml-1"
            @click="$router.go(-1)"
          >
            {{ $t('common.back') }}
          </b-button>
        </b-col>
      </b-row>

      <!-- Activity Logs Section -->
      <b-row
        v-if="hasPermission('view activity_logs')"
        class="mt-3"
      >
        <b-col cols="12">
          <b-card header="سجل النشاطات">
            <ActivityLogs
              :model-type="'governorate'"
              :model-id="Number($route.params.id)"
              :show-filters="true"
              :per-page="15"
            />
          </b-card>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BBadge, BButton,
} from 'bootstrap-vue'
import { mapGetters } from 'vuex'
import ActivityLogs from '@/components/ActivityLogs.vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BBadge,
    BButton,
    ActivityLogs,
  },
  computed: {
    ...mapGetters({
      governorate: 'governorates/governorate',
    }),
  },
  mounted() {
    this.$store.dispatch('governorates/get', this.$route.params.id)
  },
  methods: {
    hasPermission(permission) {
      const userPermissions = this.$store.getters['users/user_permissions']
      if (Array.isArray(userPermissions)) {
        return userPermissions.includes(permission)
      }
      return Object.values(userPermissions || {}).includes(permission)
    },
  },
}
</script>
